import Select from 'components/Formik/Select';
import Checkboxes from 'components/Formik/Checkboxes';
import { useEffect } from 'react';

const TopicsOfInterest = ({ formik, initialValues, data, checkbox }) => {
    initialValues.Topics_Of_Interest__c = [];
    useEffect(() => {
        if (formik.values.marketingRequested === 'no') {
            formik.values.Topics_Of_Interest__c = [];
        }
    }, [formik.values.marketingRequested]);
    const { label, options, placeholder } = data;
    return (
        <>
            {!checkbox && formik.values.marketingRequested === 'yes' && (
                <Select
                    options={options}
                    label={label}
                    placeholder={placeholder}
                    isMulti
                    name="Topics_Of_Interest__c"
                />
            )}
            {checkbox && formik.values.marketingRequested === 'yes' && (
                <>
                    <p>
                        <strong>{label}</strong>
                    </p>
                    <Checkboxes
                        options={options}
                        label={label}
                        name="Topics_Of_Interest__c"
                    />
                </>
            )}
        </>
    );
};

export default TopicsOfInterest;
